import { render, staticRenderFns } from "./DeleteBrigadeActiveRequests.vue?vue&type=template&id=436e814d&scoped=true&"
import script from "./DeleteBrigadeActiveRequests.vue?vue&type=script&lang=js&"
export * from "./DeleteBrigadeActiveRequests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436e814d",
  null
  
)

export default component.exports
import {QCard,QCardSection,QItem,QInput,QTable,QTr,QTh,QTd,QBtn,QTooltip,QSeparator,QItemSection,QIcon,QCardActions,QInnerLoading,QSpinnerGears,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QItem,QInput,QTable,QTr,QTh,QTd,QBtn,QTooltip,QSeparator,QItemSection,QIcon,QCardActions,QInnerLoading,QSpinnerGears}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
